import moment from 'moment';

export default class ModelSpreadsheetCalculation {
  constructor(data) {
    this.Id = data.Id;
    this.CalculationId = data.CalculationId || null;
    this.ModelId = data.ModelId;
    this.ModelName = data.ModelName || null;
    this.ModelFileName = data.ModelFileName || null;
    this.ColumnCount = data.ColumnCount;
    this.RowCount = data.RowCount;
    this.StartRow = data.StartRow;
    this.EndRow = data.EndRow;
    this.ExecutionDuration = data.ExecutionDuration || null;
    this.DataSource = data.DataSource || null;
    this.Columns = data.Columns || [];
    // Count of warnings produced during this run (today this is the number
    // of rows removed by date alignment). Surface the badge so admins can
    // see at a glance which calculations need review without fetching the
    // full warnings list. The full list itself is fetched lazily via
    // GET /api/spreadsheets/{id}/warnings.
    this.WarningsCount = typeof data.WarningsCount === 'number' ? data.WarningsCount : 0;

    // Per-user edited-sibling metadata. Original rows have a null
    // OriginalSpreadsheetCalculationId; edited copies carry the original's
    // DB id and HasEdits mirrors that as a boolean for the UI.
    this.OriginalSpreadsheetCalculationId =
      typeof data.OriginalSpreadsheetCalculationId === 'number'
        ? data.OriginalSpreadsheetCalculationId
        : null;
    this.HasEdits =
      typeof data.HasEdits === 'boolean'
        ? data.HasEdits
        : this.OriginalSpreadsheetCalculationId != null;
    this.ModifiedCellsCount =
      typeof data.ModifiedCellsCount === 'number' ? data.ModifiedCellsCount : 0;

    if (data.CreateTime !== undefined) {
      this.CreateTime = data.CreateTime === null ? null : moment.utc(data.CreateTime);
    }
  }

  getFormattedCreateTime() {
    return this.CreateTime ? this.CreateTime.local().format('L LTS') : '';
  }
}

